import { axios } from '../../services/axios';

const uploadServiceDefinitionLogo = async ({
    wholesalerId,
    serviceDefinitionID,
    payload,
    scope,
}) => {
    console.log(
        'Uploading logo for Service Definition ID:',
        serviceDefinitionID,
    );
    const result = await axios.post(
        `/ServiceProfile/OperatorPlatform/Wholesaler/${wholesalerId}/ServiceDefinition/${serviceDefinitionID}/Logo`,
        payload,
        {
            headers: {
                'X-RequestScope': scope,
            },
        },
    );
    return result;
};

export default uploadServiceDefinitionLogo;
